var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeparador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.55,
    height: 156,
    viewBox: "0 0 21.55 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(-788.738 -6066.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M478.2,949.421l3.329,7.272,7.444,1.165-5.388,5.661,1.273,7.993-6.659-3.775-6.662,3.775,1.273-7.993-5.388-5.661,7.444-1.165Z",
    transform: "translate(321.316 5184.279)",
    fill: "#ba0008"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_2",
    "data-name": "L\\xEDnea 2",
    y2: 55,
    transform: "translate(799.5 6066.5)",
    fill: "none",
    stroke: "#ba0008",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_3",
    "data-name": "L\\xEDnea 3",
    y2: 55,
    transform: "translate(799.5 6167.5)",
    fill: "none",
    stroke: "#ba0008",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeparador);
export default __webpack_public_path__ + "static/media/ceparador.947090e8189617fe67d25ca4ecc29311.svg";
export { ForwardRef as ReactComponent };